export default __webpack_public_path__ + "static/media/adobe-master.58192f6f.gif";